import { troubleControllerAisStatus } from './troubleControllerAisStatus'
import { troubleControllerDownloadTest } from './troubleControllerDownloadTest'
import { troubleControllerUploadTest } from './troubleControllerUploadTest'

export const troubleService = { troubleControllerUploadTest, troubleControllerDownloadTest, troubleControllerAisStatus }